export default __webpack_public_path__ + "static/media/brachot-hanenim-mission.5260b50c.png";